import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _displayComponentProp;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { DEFAULT_LABEL } from './WebsiteComponentInteraction.constants';
import { DisplayComponentPropsMapPropType } from './WebsiteComponentInteraction.proptypes';
import { getDisplayComponent, getDisplayComponentProps } from './WebsiteComponentInteraction.utils';
import { WebsiteComponentInteractionPropType, ChildrenPropType } from '../../../../services/proptypes';
import { EventPropType } from '../../../analytics/types';
import { INTERACTION_DISPLAY_TYPE_BUTTON, INTERACTION_DISPLAY_TYPE_ICON } from '../../constants';
import './WebsiteComponentInteraction.css';
var defaultProps = {
  className: '',
  content: '',
  children: null,
  displayComponentPropsMap: (_displayComponentProp = {}, _defineProperty(_displayComponentProp, INTERACTION_DISPLAY_TYPE_BUTTON, {
    size: 'tiny',
    compact: true
  }), _defineProperty(_displayComponentProp, INTERACTION_DISPLAY_TYPE_ICON, {}), _displayComponentProp),
  event: null
};
function WebsiteComponentInteraction(_ref) {
  var interaction = _ref.interaction,
    className = _ref.className,
    content = _ref.content,
    children = _ref.children,
    displayComponentPropsMap = _ref.displayComponentPropsMap,
    event = _ref.event;
  var label = interaction.label,
    enabled = interaction.enabled;
  if (!enabled) {
    return null;
  }
  var displayComponentProps = getDisplayComponentProps({
    interaction: interaction,
    displayComponentPropsMap: displayComponentPropsMap,
    className: className,
    event: event
  });
  var DisplayComponent = getDisplayComponent(interaction);
  return /*#__PURE__*/React.cloneElement(DisplayComponent, _objectSpread(_objectSpread({}, displayComponentProps), {}, {
    children: children || content || label || DEFAULT_LABEL
  }));
}
WebsiteComponentInteraction.defaultProps = defaultProps;
export default WebsiteComponentInteraction;